import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import LocaleStrings from "Languages";
import { Modal } from "react-bootstrap";
import Iframe from "react-iframe";
import { DOMAIN_NAME } from "Constants";

// Import Actions
import { broadcastPolls } from "PollAction";

const BroadCastLivePolls = (props) => {
  let { broadcastLivePolls, eventData, selectedSession } = props;

  let url =
    eventData && eventData.seocode
      ? `https://${eventData.seocode}.${DOMAIN_NAME}/o/#/live-poll/${selectedSession}`
      : `https://${DOMAIN_NAME}/o/#/`;

  const closeModal = () => {
    // Polls & Live QA -> Polls [Open big modal which will show embaded links for live polls]
    props.broadcastPolls({ showModal: false });
  };

  return (
    <div>
      <div>
        <Modal
          className="modal-container broadcast-modal"
          show={
            broadcastLivePolls && broadcastLivePolls.showModal === true
              ? true
              : false
          }
          onHide={() => closeModal()}
          animation={true}
        >
          <Modal.Body>
            <div className="broadcast-import-header">
              <div className="broadcast-import-modal-title">
                {LocaleStrings.polls_qa_text_live_polls}
              </div>
              <button
                type="button"
                className="close btn-sm btn-close "
                onClick={() => closeModal()}
                style={{ marginTop: -60 }}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div style={{ padding: "0px 20px 20px" }}>
              <div className="livepoll-oderd-purchase-container">
                <Iframe
                  // url={"https://eventify.io/"}
                  url={url}
                  width="100%"
                  height="100%"
                  id="webbrowser"
                  display="initial"
                  position="relative"
                />
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    session: state.session,
    broadcastLivePolls: state.broadcastLivePolls,
    eventData: state.userEventDetails,
    selectedSession: state.selectedSession.resource,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ broadcastPolls }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(BroadCastLivePolls);
